import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../utils/ModalEventListener";
import { toast } from "react-toastify";
import SingleSelectDropDown from "../../layouts/SingleSelectDropDown";
import { axios_instance } from "../../api/axios_instance";
import { encryptRequest } from "../../utils/encryptdecryptrequest";

const CopyEnvConfigModal = ({
  EnvTypes,
  fetchConfigData,
  closeCopyEnvConfigModal,
}) => {
  const [state, setState] = useState({
    sourceEnvType: "",
    destEnvType: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeCopyEnvConfigModal);
  }, [closeCopyEnvConfigModal]);

  const handleInputChange = (e, inputName) => {
    setState({ ...state, [inputName]: e.target.value });
  };

  const EnvTypeList = EnvTypes.map((envVal) => {
    return { text: envVal.text, value: envVal.id ? envVal.id : "" };
  });

  const copyEnvData = async () => {
    toast.dismiss();
    try {
      setIsLoading(true);
      const reqData = encryptRequest({
        sourceEnvType: state.sourceEnvType,
        destEnvType: state.destEnvType,
      });
      const configData = await axios_instance({
        url: "/envConfig/copyEnvConfigData",
        method: "POST",
        data: { reqData },
      });
      if (configData.status === 200) {
        await fetchConfigData(false, true, true);
        toast.success(
          configData?.data?.result?.msg
            ? configData.data.result.msg
            : "Data Copied Successfully",
          { theme: "colored" }
        );
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message, { theme: "colored" });
      } else {
        toast.error("Something went wrong", { theme: "colored" });
      }
      closeCopyEnvConfigModal();
    } finally {
      setIsLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-wrapper">
      <div className="copy-env-config-modal-content" ref={ref}>
        <div className="modal-header">
          <button className="close" onClick={closeCopyEnvConfigModal}>
            <span>&times;</span>
          </button>
          <h4 className="modal-title" id="configModalLabel">
            Copy Env Config
          </h4>
        </div>

        <div id="copyEnvConfigForm" name="copyEnvConfigForm">
          <div className="modal-body">
            <div className="form-group clearfix">
              <div className="col-md-3">
                <div className="text-label">
                  Source Env <span className="col-red">*</span>
                </div>
              </div>
              <SingleSelectDropDown
                divClassName="col-md-9"
                dataArr={EnvTypeList}
                handleChange={(e) => handleInputChange(e, "sourceEnvType")}
                name="source_env_type"
                value={state.sourceEnvType}
              />
            </div>
            <div className="form-group clearfix">
              <div className="col-md-3">
                <div className="text-label">
                  Destination Env <span className="col-red">*</span>
                </div>
              </div>
              <SingleSelectDropDown
                divClassName="col-md-9"
                dataArr={EnvTypeList}
                handleChange={(e) => handleInputChange(e, "destEnvType")}
                name="destination_env_type"
                value={state.destEnvType}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="copy_env_config_btn"
              name="copy_env_config_btn"
              className="btn rc-btn_primary"
              disabled={isLoading}
              onClick={copyEnvData}
            >
              {isLoading ? "Please wait.." : "Save"}
            </button>
            <button
              type="button"
              disabled={isLoading}
              className="btn rc-btn_rset"
              onClick={closeCopyEnvConfigModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default CopyEnvConfigModal;
